import React, { useState } from "react";
import {
  Toolbar,
  IconButton,
  Box,
  Drawer,
  AppBar,
  Stack,
  Divider,
} from "@mui/material";
import { CgMenuRight } from "react-icons/cg";
import LinksDrawer from "./LinksDrawer";
import AppLogo from "./AppLogo";
import ThemeToggler from "../buttons/ThemeToggler";
import UserMenu from "../buttons/UserMenu";

const SideDrawer = () => {
  const [drawerWidth, setDrawerWidth] = useState(260);
  const [showLinkIconsOnly, setShowLinkIconsOnly] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    if (showLinkIconsOnly) {
      setShowLinkIconsOnly(false);
      setDrawerWidth(260);
    }
  };

  const drawerSx = [
    {
      "& .MuiDrawer-paper": {
        boxSizing: "border-box",
        width: drawerWidth,
        transition: "width 200ms",
        py: 2,
        borderRight: "none",
        borderLeft: "1px solid",
        borderColor: "divider",
        overflowX: "hidden",
        bgcolor: "background.elevated",
      },
    },
  ];

  const drawerContent = (
    <>
      <AppLogo showLinkIconsOnly={showLinkIconsOnly} />
      <Divider sx={{ mx: 2, mt: 2, mb: 1 }} />
      <LinksDrawer showLinkIconsOnly={showLinkIconsOnly} />
    </>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {/* Top bar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          transition: "width 200ms",
          backgroundImage: "none",
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.elevated",
          color: "text.primary",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Desktop: collapse sidebar */}
          <IconButton
            aria-label="toggle sidebar"
            sx={{ display: { xs: "none", md: "flex" } }}
            onClick={() => {
              setShowLinkIconsOnly(!showLinkIconsOnly);
              setDrawerWidth(showLinkIconsOnly ? 260 : 64);
            }}
          >
            <CgMenuRight />
          </IconButton>
          {/* Mobile: open drawer */}
          <IconButton
            aria-label="open drawer"
            sx={{ display: { xs: "flex", md: "none" } }}
            onClick={handleDrawerToggle}
          >
            <CgMenuRight />
          </IconButton>

          <Stack direction="row" alignItems="center" gap={0.5}>
            <ThemeToggler />
            <UserMenu />
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Sidebar nav */}
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 }, transition: "width 200ms" }}
      >
        {/* Mobile drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={[{ display: { xs: "block", md: "none" } }, ...drawerSx]}
        >
          {drawerContent}
        </Drawer>

        {/* Desktop drawer */}
        <Drawer
          variant="permanent"
          open
          sx={[{ display: { xs: "none", md: "block" } }, ...drawerSx]}
        >
          {drawerContent}
        </Drawer>
      </Box>
    </Box>
  );
};

export default SideDrawer;
